import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MaskSettings } from '@bazis/form/models/form-element.types';
import { debounceTime, tap } from 'rxjs/operators';
import { UntilDestroy } from '@ngneat/until-destroy';
import { initialConfig } from 'ngx-mask';
import {
    FOREIGN_PHONE_INPUT_TRANSFORM_FN,
    FOREIGN_PHONE_MASK_SETTINGS,
    PHONE_INPUT_TRANSFORM_FN,
    PHONE_MASK_SETTINGS,
    PHONE_PATTERN,
    FOREIGN_PHONE_PATTERN,
} from '@bazis/configuration.service';
import { BazisControlValueAccessor } from '@bazis/form/components/control-value-accessor.component';

@UntilDestroy()
@Component({
    selector: 'bazis-input-phone',
    templateUrl: './input-phone.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BazisInputPhoneComponent extends BazisControlValueAccessor {
    @Input() rfMaskSettings: Partial<MaskSettings> = PHONE_MASK_SETTINGS;

    @Input() rfBeforeWrite: (value: string | null) => string | null = PHONE_INPUT_TRANSFORM_FN;

    @Input() foreignMaskSettings: Partial<MaskSettings> = FOREIGN_PHONE_MASK_SETTINGS;

    @Input() foreignBeforeWrite: (value: string | null) => string | null =
        FOREIGN_PHONE_INPUT_TRANSFORM_FN;

    // наличие внутренних отступов
    @Input() withoutInnerPadding: boolean = false;

    @Input() enableForeignNumber: boolean = true;

    @Input() defaultMask: 'rf' | 'foreign' = 'rf';

    public field = new FormControl('');

    maskSettings;

    beforeWrite;

    currentMaskType;

    valueChanges$ = this.field.valueChanges.pipe(
        debounceTime(0),
        tap((value) => {
            this.onChange(value);
        }),
    );

    statusChanges$ = this.field.statusChanges.pipe(
        debounceTime(0),
        tap((status) => {
            if (status === 'INVALID') {
                this.ngControl.control.setErrors({
                    ...this.ngControl.control.errors,
                    componentError: true,
                });
            } else {
                const errors = this.ngControl.control.errors;
                if (errors) {
                    delete errors.componentError;
                    this.ngControl.control.setErrors({ ...errors });
                }
            }
        }),
    );

    extendOnInit() {
        this.currentMaskType = this.defaultMask;
        this.setMask(this.currentMaskType);

        this.canEraserShow = !this.field.disabled && this.hasEraser;
    }

    public setDisabledState(isDisabled: boolean): void {
        if (isDisabled) {
            this.field.disable();
        } else {
            this.field.enable();
        }
    }

    public writeValue(value: any): void {
        if (!this.ngControl.control) return;
        this.setMaskByValue(value);
        this.field.setValue(value, { emitEvent: false });
    }

    setMaskByValue(value) {
        if (!value) return;
        this.setMask(value.indexOf('+7') === 0 && value.length === 12 ? 'rf' : 'foreign');
    }

    setMask(type: 'rf' | 'foreign') {
        this.currentMaskType = type;
        if (type === 'rf') {
            this.maskSettings = {
                ...initialConfig,
                ...this.rfMaskSettings,
            };
            this.beforeWrite = this.rfBeforeWrite;
            this.field.setValidators([Validators.pattern(PHONE_PATTERN)]);
        }
        if (type === 'foreign') {
            this.maskSettings = {
                ...initialConfig,
                ...this.foreignMaskSettings,
            };
            this.beforeWrite = this.foreignBeforeWrite;
            this.field.setValidators([Validators.pattern(FOREIGN_PHONE_PATTERN)]);
        }
        this.field.updateValueAndValidity();
    }

    changeMaskType() {
        this.field.setValue(null);
        this.setMask(this.currentMaskType === 'rf' ? 'foreign' : 'rf');
    }
}
